import { 
  CardIcon, 
  MailIcon, 
  PhoneIcon 
} from "../icons/assets";


export default function TopBanner() {
  return (
    <div className="bg-neutral-900 text-primary-foreground py-2 px-4 md:px-8 lg:px-20 relative">
      <div className="flex items-center justify-center md:justify-between">
        <div className="flex items-center gap-2">
          <CardIcon />
          <span className="text-sm md:text-base">Free shipping on all orders</span>
        </div>
        <div className="hidden md:flex items-center gap-6">
          <a
            href="mailto:question@wheeltox.com"
            className="flex items-center gap-2"
          >
            <MailIcon className="" />
            <span>question@wheeltox.com</span>
          </a>
          <a
            href="tel:0397968925"
            className="flex items-center gap-2"
          >
            <PhoneIcon className="" />
            <span>(03) 9796 8925</span>
          </a>
        </div>
      </div>
    </div>
  );
}
